import React, { useEffect, useState } from 'react';
import { makeStyles, Tooltip } from '@material-ui/core';
import Button from 'components/CustomButtons/Button.js';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { Assignment, Cached } from '@material-ui/icons';
import FilterArticle from 'hooks/FilterArticle';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { WithApp } from 'contexts/appContext';

import { DataStock, DataStockInvalid } from './StockData';
import { Toasty, useToasty } from 'hooks/Toasty';
import { wsFindBy, wsGetAll, wsPost } from 'services/WService';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    fontSize: '18px',
    display: 'flex',
    justifyContent: 'space-between'
  }
});

export default WithApp(function Stock(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const [stocks, setStocks] = useState([]);
  const [stockInvalids, setStockInvalids] = useState([]);
  const [invalid, setInvalid] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  async function listStocks(search) {
    setDataLoading(true);
    if (!search) {
      showNotify('Elija los filtros para mostrar resultados', 'info');
      setStocks([]);
      return;
    }
    let response = await wsFindBy('logi/stock', search);
    setDataLoading(false);
    if (response.success) setStocks(response.data);
  }

  async function listStockInvalid() {
    setDataLoading(true);
    let response = await wsGetAll('logi/stock/invalid');
    setDataLoading(false);
    if (response.success) setStockInvalids(response.data);
  }

  async function refreshStockInvalids() {
    setDataLoading(true);
    let response = await wsPost('logi/stock/sync');
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      listStockInvalid();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (invalid) listStockInvalid();
  }, [invalid]);

  return (
    <>
      <Toasty action={notify} />
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <div className={classes.cardIconTitle}>
            <span>Listado stocks {invalid ? 'inválidos' : 'normales'} {dataLoading && <LoadingSpinner />}</span>
            
            <div>
              <Tooltip title="Refrescar stocks">
                <Button
                  onClick={() => refreshStockInvalids()}
                  size="sm"
                  round
                  justIcon
                  color={props.themeContext.buttonColorWarning}
                  style={{ marginRight: '10px' }}
                >
                  <Cached />
                </Button>
              </Tooltip>
              <Button
                onClick={() => setInvalid(!invalid)}
                size="sm"
                color={invalid ? 'info' : 'danger'}
              >
                {invalid ? 'Stock normal' : 'Stock inválido'}
              </Button>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          {!invalid ? (
            <FilterArticle
              getFilter={listStocks}
              article
              mark //quieres q se muetre marca
              warehouse
            />
          ) : undefined}

          {invalid ? DataStockInvalid(stockInvalids) : DataStock(stocks)}
        </CardBody>
      </Card>
    </>
  );
});
